export const EditJobTemplateLineItemAction = ({ disabled, onClickSingle }) => ({
  label: "Edit",
  icon: "edit-square-md",
  disabled,
  onClickSingle,
})

export const RemoveJobTemplateLineItemAction = ({
  disabled,
  onClickSingle,
}) => ({
  label: "Remove",
  icon: "sf-trashcan",
  danger: true,
  disabled,
  onClickSingle,
})
